// @core/api/endpoints/search/bulk_index_documents.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BulkIndexDocumentsRequest,
  BulkIndexDocumentsResponse,
} from '../../../types/search';

const BASE_PATH = '/search';

/**
 * Bulk index documents
 * Indexes multiple documents in a single batch operation. Used by the internal indexing pipeline for efficiency.
 */
export async function BulkIndexDocuments(
  data: BulkIndexDocumentsRequest,
  options?: RequestOptions
): Promise<BulkIndexDocumentsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/search/documents/bulk`;
  const requestOptions = options;
  return client.post<BulkIndexDocumentsResponse>(requestPath, data, requestOptions);
}
